// import React, { useEffect, useState } from 'react';
// import { Card, CardContent, CardMedia, Grid, Typography, Box } from '@mui/material';
// import axios from 'axios';

// const Gallery = () => {
//     const [galleryImages, setGalleryImages] = useState([]);
//     const [loading, setLoading] = useState(true);
//     const [error, setError] = useState(null);

//     useEffect(() => {
//         const fetchImages = async () => {
//             try {
//                 const response = await axios.get('https://wedding-backend-pi.vercel.app/api/gallery/images');
//                 console.log(response.data); 
//                 setGalleryImages(response.data); 
//                 setLoading(false);
//             } catch (err) {
//                 console.error(err);
//                 setError('Failed to fetch images.');
//                 setLoading(false);
//             }
//         };
//         fetchImages();
//     }, []);

//     if (loading) {
//         return <Typography align="center" variant="h6">Loading...</Typography>;
//     }

//     if (error) {
//         return <Typography align="center" variant="h6" color="error">{error}</Typography>;
//     }

//     if (!Array.isArray(galleryImages) || galleryImages.length === 0) {
//         return <Typography align="center" variant="h6">No images to display.</Typography>;
//     }

//     return (
//         <Box sx={{ flexGrow: 1, marginTop: 4 }}>
//             <Typography variant="h4" align="center" gutterBottom>
//                 Gallery
//             </Typography>
//             <Grid container spacing={4} justifyContent="center">
//                 {galleryImages.map((image, index) => (
//                     <Grid item xs={12} sm={6} md={4} key={index}>
//                         <Card sx={{
//                             position: 'relative',
//                             overflow: 'hidden',
//                             borderRadius: 2,
//                             '&:hover .cardMedia': {
//                                 transform: 'scale(1.1)',
//                                 transition: 'transform 0.5s ease',
//                             },
//                         }}>
//                             <CardMedia
//                                 className="cardMedia"
//                                 sx={{
//                                     height: 0,
//                                     paddingTop: '56.25%',
//                                     transition: 'transform 0.5s ease',
//                                 }}
//                                 image={image.secure_url}
//                                 title={image.title}
//                             />
//                             <CardContent sx={{
//                                 backgroundColor: 'rgba(0, 0, 0, 0.6)',
//                                 color: 'white',
//                                 position: 'absolute',
//                                 bottom: 0,
//                                 width: '100%',
//                                 padding: 2,
//                                 opacity: 0,
//                                 transition: 'opacity 0.3s ease',
//                                 '&:hover': {
//                                     opacity: 1,
//                                 },
//                             }}>
//                                 <Typography variant="h6" sx={{ fontSize: '1.2rem', fontWeight: 'bold' }}>
//                                     {image.title}
//                                 </Typography>
//                                 <Typography variant="body2">
//                                     {image.description}
//                                 </Typography>
//                             </CardContent>
//                         </Card>
//                     </Grid>
//                 ))}
//             </Grid>
//         </Box>
//     );
// };

// export default Gallery;







import React, { useEffect, useState } from 'react';
import { Card, CardContent, CardMedia, Grid, Typography, Box } from '@mui/material';
import axios from 'axios';

const Gallery = () => {
    const [galleryImages, setGalleryImages] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        const fetchImages = async () => {
            try {
                const response = await axios.get('https://wedding-backend-pi.vercel.app/api/gallery/images');
                setGalleryImages(response.data); // Show all images
                setLoading(false);
            } catch (err) {
                console.error(err);
                setError('Failed to fetch images.');
                setLoading(false);
            }
        };
        fetchImages();
    }, []);

    if (loading) {
        return <Typography align="center" variant="h6">Loading...</Typography>;
    }

    if (error) {
        return <Typography align="center" variant="h6" color="error">{error}</Typography>;
    }

    return (
        <Box sx={{ flexGrow: 1, marginTop: 4 }}>
            <Typography variant="h4" align="center" gutterBottom>
                Gallery
            </Typography>
            <Grid container spacing={4} justifyContent="center">
                {galleryImages.map((image, index) => (
                    <Grid item xs={12} sm={6} md={4} key={index}>
                        <Card sx={{
                            position: 'relative',
                            overflow: 'hidden',
                            borderRadius: 2,
                            '&:hover .cardMedia': {
                                transform: 'scale(1.1)',
                                transition: 'transform 0.5s ease',
                            },
                        }}>
                            <CardMedia
                                className="cardMedia"
                                sx={{
                                    height: 0,
                                    paddingTop: '56.25%',
                                    transition: 'transform 0.5s ease',
                                }}
                                image={image.secure_url}
                                title={image.title}
                            />
                            <CardContent sx={{
                                backgroundColor: 'rgba(0, 0, 0, 0.6)',
                                color: 'white',
                                position: 'absolute',
                                bottom: 0,
                                width: '100%',
                                padding: 2,
                                opacity: 0,
                                transition: 'opacity 0.3s ease',
                                '&:hover': {
                                    opacity: 1,
                                },
                            }}>
                                <Typography variant="h6" sx={{ fontSize: '1.2rem', fontWeight: 'bold' }}>
                                    {image.title}
                                </Typography>
                            </CardContent>
                        </Card>
                    </Grid>
                ))}
            </Grid>
        </Box>
    );
};

export default Gallery;
